module.exports = __webpack_public_path__ + "img/Icon.418ab217.svg";